// extracted by mini-css-extract-plugin
module.exports = {"button":"_1YBIjxQ_n4nnSu8RbgQPQf"};